import { formatPartName } from '@tekion/tekion-base/formatters/parts/general';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
var getOptionLabel = function getOptionLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var partLabel = formatPartName(option, '');
  if (option.isCoreOnly) {
    return "".concat(__('Core:'), " ").concat(partLabel);
  }
  return partLabel;
};
var getOptionValue = function getOptionValue() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  return option.id;
};
var PART_AND_PART_CORE_CONFIG = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue
};
export default PART_AND_PART_CORE_CONFIG;